import { UserPreferencesServiceHttpClient } from './httpClient';
import { Maybe, GenericApiType } from '../types/common';
import authorizationService from './security/authorizationService';

const baseUrl = '/PerformanceCookie/consent';

type GetCookieApiType = {
  showBanner: boolean;
};

type WindowType = Window & {
  pendo?: {
    get_visitor_id: () => string;
  };
};

export const getPendoUserId = () => {
  const email = authorizationService.getEmail() as string;
  const environmentNamespace =
    process.env.REACT_APP_ENVIRONMENT_NAMESPACE || 'local';
  const fallbackIdValue = `${environmentNamespace}_${email}`;
  const { pendo } = window as WindowType;
  const userId = pendo?.get_visitor_id
    ? pendo.get_visitor_id()
    : fallbackIdValue;
  return userId;
};

export const doNotProcessRequest = (
  userType: string,
  userId: string,
  allowProcessing: boolean
) =>
  userId && {
    userType,
    userId,
    allowProcessing,
  };

export const getShowCookiesBanner = async (): Promise<boolean> => {
  let result: Maybe<GenericApiType<GetCookieApiType>>;
  try {
    result = (await UserPreferencesServiceHttpClient.get(baseUrl)) as {
      data: {
        showBanner: boolean;
      };
    };
  } catch (e) {
    // todo log to insights
    // eslint-disable-next-line
    console.error(e);
  }
  return result?.data?.showBanner || false;
};

export const setPerformanceCookie = async (
  allowPerformanceCookie: boolean
): Promise<boolean> => {
  const doNotProcessPendoRequests = doNotProcessRequest(
    'visitor',
    getPendoUserId(),
    allowPerformanceCookie
  );
  const response = (await UserPreferencesServiceHttpClient.put(baseUrl, {
    allowPerformanceCookie,
    doNotProcessPendoRequests: [doNotProcessPendoRequests],
  })) as { data: boolean };

  return response?.data;
};
